import type { WrapUpTimeStartedUseCase } from '@usecases/wrap-up-time-started.usecase';
import type { BaseController } from '@infra/controllers/base.controller';

export class WrapUpTimeStartedController implements BaseController<void> {
  constructor(private usecase: WrapUpTimeStartedUseCase) {}

  async handle() {
    return this.usecase.run();
  }
}
